import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {Offer} from '../../../../models/Offer';
import {OffersService} from '../../../../services/offers/offers.service';
import {Router} from '@angular/router';
import {OuterSubscriber} from 'rxjs/internal-compatibility';
import {LanguageService} from '../../../../services/languages/language.service';

@Component({
  selector: 'app-offer-preview',
  templateUrl: './offer-preview.component.html',
  styleUrls: ['./offer-preview.component.scss']
})
export class OfferPreviewComponent implements OnInit {
  @Input() selectedOffer: Offer;
  @Output() xClicked: EventEmitter<any>;
  key: string;

  constructor(public offersService: OffersService, private router: Router, private languageService: LanguageService) {
    this.xClicked = new EventEmitter();
  }

  ngOnInit() {
    this.languageService.currentLanguageKey.subscribe((key) => {
      this.key = key;
    });
  }

  clickOnSeeMore(offer: Offer): void {
    this.router.navigate([this.key + '/offer/' + offer.id.toString()]);
  }

  closePreview() {
    this.xClicked.emit();
  }

  @HostListener('click') click() {
    this.clickOnSeeMore(this.selectedOffer);
  }
}
